import React from 'react';
import useUrlLevel from "@dyl/hooks/useUrlLevel";
import { useLevels } from "@dyl/systems/LevelsManager";

/**
 * Creating a level of indirection to avoid firing requests before the correct level is set (async)
 * @template {{}} P
 * @param {React.ComponentType<P>} BaseComponent
 * @param {Partial<P>} baseProps
 * @returns {React.ComponentType<P>}
 */
export default function withLevel(BaseComponent, baseProps) {
    return React.forwardRef(
        function WithLevelWrapper(props, ref) {
            const { urlLevel } = useUrlLevel();
            const { globalLevel } = useLevels();
            return (
                <>
                    {urlLevel.toLowerCase() === globalLevel.label.toLowerCase()
                        && <BaseComponent ref={ref} {...baseProps} globalLevel={globalLevel} {...props} />}
                </>
            );
        }
    );
}